import React, { useEffect, useState } from "react";
import { User, Lock, ArrowLeftCircle, Eye, EyeOff } from "react-feather"; // react-feather icons
import logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import apiPublic from "./ApiNoToken";

function Verifikasi() {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // biar tidak reload halaman
    const { password, confirmPassword } = formData;

    // Validasi kosong
    if (password.trim() === "" || confirmPassword.trim() === "") {
      toast.warning("Password dan Verifikasi Password wajib diisi.");
      return;
    }

    // Validasi panjang minimal 6 karakter
    if (password.length < 6) {
      toast.warning("Password minimal 6 karakter.");
      return;
    }

    // Validasi karakter berbahaya
    const invalidCharPattern = /[<>{}"'`$%^&*+=]/;
    if (invalidCharPattern.test(password)) {
      toast.error("Password mengandung karakter tidak diperbolehkan.");
      return;
    }

    // Validasi konfirmasi password
    if (password !== confirmPassword) {
      toast.error("Password dan Verifikasi Password tidak sama.");
      return;
    }

    try {
      const email = localStorage.getItem("resetEmail"); // ambil dari localStorage
      if (!email) {
        toast.error("Email tidak ditemukan, silakan ulangi proses.");
        navigate("/ForgotPassword");
        return;
      }

      const res = await apiPublic.post("/reset-password", {
        email,
        password,
        password_confirmation: confirmPassword,
      });

      toast.success(res.data.message || "Password berhasil direset!");
      localStorage.removeItem("otpExpiredAt"); // bersihkan data OTP
      localStorage.removeItem("emailForgot");
      navigate("/"); // arahkan ke halaman login
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.message || "Terjadi kesalahan, coba lagi."
      );
    }
  };

  return (
    <div id="auth">
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  <img src={logo} height="80" className="mb-4" alt="logo" />
                  <h3
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      fontWeight: "bold",
                      color: "#1a237e", // Biru tua, bisa disesuaikan
                      textTransform: "uppercase",
                      marginBottom: "0.2rem",
                    }}
                  >
                    PERUMDAM TKR
                  </h3>
                  <p
                    style={{
                      fontFamily: '"Arial Black", "Arial", sans-serif',
                      color: "#555555", // Abu-abu gelap
                      textTransform: "uppercase",
                      fontWeight: "normal",
                      fontSize: "0.9rem",
                      marginTop: "0",
                    }}
                  >
                    KABUPATEN TANGERANG
                  </p>
                  <p>Reset Password Anda</p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="form-group position-relative has-icon-left">
                    <div className="clearfix">
                      <label htmlFor="password">Password</label>
                    </div>
                    <div className="form-group position-relative has-icon-left">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Masukkan Password Anda"
                        value={formData.password}
                        onChange={handleChange}
                      />
                      <div className="form-control-icon">
                        <Lock size={16} />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-group position-relative has-icon-left">
                    <div className="clearfix">
                      <label htmlFor="password">Verifikasi Password</label>
                    </div>
                    <div className="form-group position-relative has-icon-left">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="confirmPassword"
                        name="confirmPassword"
                        placeholder="Masukkan Ulang Password Anda"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                      />
                      <div className="form-control-icon">
                        <Lock size={16} />
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-check clearfix my-4">
                    <div className="float-right"></div>
                    <div className="float-left"></div>
                  </div>
                  <div className="clearfix">
                    <button
                      className="btn btn-secondary float-left"
                      type="button"
                      onClick={() => window.history.back()}
                    >
                      <ArrowLeftCircle
                        size={16}
                        style={{ marginRight: "8px" }}
                      />
                      Back
                    </button>
                    <button
                      className="btn btn-primary float-right"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default Verifikasi;
